const FlagItalian = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='23' height='16' fill='none' viewBox='0 0 23 16'>
    <path fill='#CCCAC9' d='M22.732 0H0v15.279h22.732V0z'></path>
    <path fill='#248538' d='M7.648.187H.196v14.905h7.452V.187z'></path>
    <path fill='#fff' d='M15.101.187H7.648v14.905h7.453V.187z'></path>
    <path fill='#C21728' d='M22.553.187H15.1v14.905h7.453V.187z'></path>
  </svg>
)

export { FlagItalian }
